import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const StyledMenu = styled.div(props => ({
    boxShadow: `1px 1px 6px ${theme(props).legacy.shadowColor}`,
    borderBottomLeftRadius: theme(props).size(0.5),
    borderBottomRightRadius: theme(props).size(0.5),
    paddingBottom: theme(props).size(0.5),
    paddingTop: theme(props).size(0.5),
    backgroundColor: theme(props).keyPalette.primaryBackgroundColor,
    width: "100%",
}));
